(function () {
  'use strict';

  if (!window.PB_GIFT_CONFIG) return;

  var GIFT = {
    THRESHOLD:      window.PB_GIFT_CONFIG.THRESHOLD,
    PRODUCT_ID:     window.PB_GIFT_CONFIG.PRODUCT_ID,
    PRODUCT_HANDLE: window.PB_GIFT_CONFIG.PRODUCT_HANDLE,
    PLACEHOLDER_ID: null,
    VARIANTS:       {},
    COLORS:         [],
    SIZES:          [],
    _busy:          false,
    _initialized:   false
  };

  var panel   = null;
  var overlay = null;

  /* ---- carica prodotto via API ---- */
  function loadProduct() {
    return fetch('/products/' + GIFT.PRODUCT_HANDLE + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var img = document.getElementById('pbGiftImg');
        var ttl = document.getElementById('pbGiftTitle');
        if (img && product.featured_image) img.src = product.featured_image;
        if (ttl) ttl.textContent = product.title;

        product.variants.forEach(function (v) {
          var key = v.option1 + '/' + v.option2;
          GIFT.VARIANTS[key] = { id: v.id, available: v.available };
          if (!GIFT.PLACEHOLDER_ID && v.available) GIFT.PLACEHOLDER_ID = v.id;
        });

        var seenColors = {};
        product.variants.forEach(function (v) {
          if (!seenColors[v.option1]) { seenColors[v.option1] = true; GIFT.COLORS.push(v.option1); }
        });
        var seenSizes = {};
        product.variants.forEach(function (v) {
          if (!seenSizes[v.option2]) { seenSizes[v.option2] = true; GIFT.SIZES.push(v.option2); }
        });

        function colorHasStock(color) {
          return product.variants.some(function (v) { return v.option1 === color && v.available; });
        }
        function sizeHasStock(size) {
          return product.variants.some(function (v) { return v.option2 === size && v.available; });
        }

        var colorsContainer = document.getElementById('pbGiftColors');
        GIFT.COLORS.forEach(function (color) {
          var avail = colorHasStock(color);
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'pbGiftBtn pbGiftColor';
          btn.dataset.value = color;
          btn.textContent = color;
          btn.style.cssText = 'padding:7px 14px;border:1.5px solid #ddd;border-radius:6px;background:#fff;color:#000;font-size:13px;transition:all .2s;' + (!avail ? 'opacity:.35;cursor:not-allowed;text-decoration:line-through;' : 'cursor:pointer;');
          if (!avail) btn.disabled = true;
          colorsContainer.appendChild(btn);
        });

        var sizesContainer = document.getElementById('pbGiftSizes');
        GIFT.SIZES.forEach(function (size) {
          var avail = sizeHasStock(size);
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'pbGiftBtn pbGiftSize';
          btn.dataset.value = size;
          btn.textContent = size;
          btn.style.cssText = 'padding:7px 14px;border:1.5px solid #ddd;border-radius:6px;background:#fff;color:#000;font-size:13px;transition:all .2s;' + (!avail ? 'opacity:.35;cursor:not-allowed;text-decoration:line-through;' : 'cursor:pointer;');
          if (!avail) btn.disabled = true;
          sizesContainer.appendChild(btn);
        });

        GIFT._initialized = true;
      });
  }

  /* ---- cart API ---- */
  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function cartAdd(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: { '_is_free_gift': 'true' }
      })
    }).then(function (r) { return r.json(); });
  }

  function cartRemove(lineIndex) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: lineIndex, quantity: 0 })
    }).then(function (r) { return r.json(); });
  }

  /* ---- helpers carrello ---- */
  function getGiftItem(cart) {
    if (!cart || !cart.items || !Array.isArray(cart.items)) return null;
    return cart.items.find(function (item) {
      return item.product_id === GIFT.PRODUCT_ID
        && item.properties
        && item.properties['_is_free_gift'] === 'true';
    }) || null;
  }

  function getGiftLineIndex(cart) {
    if (!cart || !cart.items || !Array.isArray(cart.items)) return null;
    var idx = cart.items.findIndex(function (item) {
      return item.product_id === GIFT.PRODUCT_ID
        && item.properties
        && item.properties['_is_free_gift'] === 'true';
    });
    return idx === -1 ? null : idx + 1;
  }

  function getVariantId(color, size) {
    var key = color + '/' + size;
    return GIFT.VARIANTS[key] ? GIFT.VARIANTS[key].id : null;
  }

  function isComboAvailable(color, size) {
    var key = color + '/' + size;
    return GIFT.VARIANTS[key] ? GIFT.VARIANTS[key].available : false;
  }

  /* ---- nascondi qty controls per omaggio nel drawer ---- */
  function lockGiftQty() {
    document.querySelectorAll('.cart-item, [id^="CartDrawer-Item-"]').forEach(function (item) {
      var link = item.querySelector('a.pName, a[href*="top-omaggio"]');
      if (!link) return;
      if (link.href && link.href.indexOf('top-omaggio') === -1) return;
      var qtyInput = item.querySelector('quantity-input');
      if (qtyInput) qtyInput.style.display = 'none';
      var removeBtn = item.querySelector('cart-remove-button');
      if (removeBtn) removeBtn.style.display = 'none';
    });
  }

  /* ---- drawer refresh ---- */
  function refreshDrawer(callback) {
    var cdi = document.querySelector('cart-drawer-items');
    if (cdi && typeof cdi.onCartUpdate === 'function') {
      cdi.onCartUpdate();
      setTimeout(function () {
        lockGiftQty();
        if (callback) callback();
      }, 800);
    }
  }

  /* ---- panel ---- */
  function openPanel(currentColor, currentSize) {
    if (!panel) return;

    panel.querySelectorAll('.pbGiftBtn:not([disabled])').forEach(function (btn) {
      btn.style.borderColor = '#ddd';
      btn.style.background  = '#fff';
      btn.style.color       = '#000';
      btn.style.fontWeight  = '';
    });
    document.getElementById('pbGiftSelectedColor').textContent = '';
    document.getElementById('pbGiftSelectedSize').textContent  = '';
    document.getElementById('pbGiftError').style.display       = 'none';
    document.getElementById('pbGiftConfirm').disabled          = true;
    document.getElementById('pbGiftConfirm').style.opacity     = '.4';

    if (currentColor) {
      var cb = panel.querySelector('.pbGiftColor[data-value="' + currentColor + '"]:not([disabled])');
      if (cb) activateBtn(cb);
    }
    if (currentSize) {
      var sb = panel.querySelector('.pbGiftSize[data-value="' + currentSize + '"]:not([disabled])');
      if (sb) activateBtn(sb);
    }
    updateConfirm();

    overlay.style.display = 'block';
    panel.style.display   = 'block';
    panel.getBoundingClientRect();
    panel.style.transform = 'translateY(0)';
  }

  function closePanel() {
    if (!panel) return;
    panel.style.transform = 'translateY(100%)';
    overlay.style.display = 'none';
    setTimeout(function () { panel.style.display = 'none'; }, 350);
  }

  function activateBtn(btn) {
    var isColor = btn.classList.contains('pbGiftColor');
    panel.querySelectorAll(isColor ? '.pbGiftColor' : '.pbGiftSize').forEach(function (b) {
      b.style.borderColor = '#ddd';
      b.style.background  = '#fff';
      b.style.color       = '#000';
      b.style.fontWeight  = '';
    });
    btn.style.borderColor = '#000';
    btn.style.background  = '#000';
    btn.style.color       = '#fff';
    btn.style.fontWeight  = '600';
    document.getElementById(isColor ? 'pbGiftSelectedColor' : 'pbGiftSelectedSize').textContent = btn.dataset.value;
  }

  function getSelected(type) {
    var cls = type === 'color' ? '.pbGiftColor' : '.pbGiftSize';
    var btns = panel.querySelectorAll(cls);
    for (var i = 0; i < btns.length; i++) {
      var bg = btns[i].style.background;
      if (bg === 'rgb(0, 0, 0)' || bg === '#000') return btns[i].dataset.value;
    }
    return null;
  }

  function updateConfirm() {
    var color      = getSelected('color');
    var size       = getSelected('size');
    var confirmBtn = document.getElementById('pbGiftConfirm');
    var errorEl    = document.getElementById('pbGiftError');

    if (!color || !size) {
      confirmBtn.disabled      = true;
      confirmBtn.style.opacity = '.4';
      errorEl.style.display    = 'none';
      return;
    }
    if (!isComboAvailable(color, size)) {
      confirmBtn.disabled      = true;
      confirmBtn.style.opacity = '.4';
      errorEl.textContent      = 'Combinazione non disponibile, scegli un\'altra opzione.';
      errorEl.style.display    = 'block';
    } else {
      confirmBtn.disabled      = false;
      confirmBtn.style.opacity = '1';
      errorEl.style.display    = 'none';
    }
  }

  /* ---- logica principale ---- */
  function checkAndManageGift() {
    GIFT._busy = false;
    GIFT._busy = true;

    fetchCart().then(function (cart) {
      if (!cart || !cart.items || typeof cart.total_price === 'undefined') {
        GIFT._busy = false;
        return;
      }

      var total = cart.total_price;
      var gift  = getGiftItem(cart);

      if (total >= GIFT.THRESHOLD) {
        if (!gift) {
          if (!GIFT.PLACEHOLDER_ID) { GIFT._busy = false; return; }
          cartAdd(GIFT.PLACEHOLDER_ID).then(function () {
            refreshDrawer(function () {
              openPanel(null, null);
            });
            GIFT._busy = false;
          }).catch(function () { GIFT._busy = false; });
        } else {
          lockGiftQty();
          GIFT._busy = false;
        }
      } else {
        if (gift) {
          var lineIdx = getGiftLineIndex(cart);
          cartRemove(lineIdx).then(function () {
            closePanel();
            refreshDrawer();
            GIFT._busy = false;
          }).catch(function () { GIFT._busy = false; });
        } else {
          GIFT._busy = false;
        }
      }
    }).catch(function () { GIFT._busy = false; });
  }

  /* ---- observer apertura drawer ---- */
  function watchDrawerOpen() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (cartDrawer.classList.contains('active')) {
            setTimeout(checkAndManageGift, 300);
          }
        }
      });
    });

    observer.observe(cartDrawer, { attributes: true });
  }

  /* ---- boot ---- */
  document.addEventListener('DOMContentLoaded', function () {
    panel   = document.getElementById('pbGiftDrawer');
    overlay = document.getElementById('pbGiftOverlay');
    if (!panel || !overlay) return;

    loadProduct().then(function () {

      // click opzioni
      panel.addEventListener('click', function (e) {
        var btn = e.target.closest('.pbGiftBtn');
        if (!btn || btn.disabled) return;
        e.preventDefault();
        activateBtn(btn);
        updateConfirm();
      });

      // chiudi
      document.getElementById('pbGiftClose').addEventListener('click', closePanel);
      overlay.addEventListener('click', closePanel);

      // conferma variante
      document.getElementById('pbGiftConfirm').addEventListener('click', function () {
        var color = getSelected('color');
        var size  = getSelected('size');
        if (!color || !size || !isComboAvailable(color, size)) return;

        var newVariantId = getVariantId(color, size);
        if (!newVariantId) return;

        var confirmBtn = document.getElementById('pbGiftConfirm');
        var spinner    = document.getElementById('pbGiftSpinner');
        var txt        = document.getElementById('pbGiftConfirmTxt');

        confirmBtn.disabled      = true;
        spinner.style.display    = 'inline-block';
        txt.style.opacity        = '.4';

        fetchCart().then(function (cart) {
          var gift = getGiftItem(cart);
          if (gift && gift.variant_id === newVariantId) {
            closePanel();
            return Promise.resolve();
          }
          if (gift) {
            return cartRemove(getGiftLineIndex(cart)).then(function () {
              return cartAdd(newVariantId);
            });
          }
          return cartAdd(newVariantId);
        }).then(function () {
          closePanel();
          refreshDrawer();
        }).catch(function (e) {
          console.error('PB Gift error:', e);
        }).finally(function () {
          confirmBtn.disabled      = false;
          spinner.style.display    = 'none';
          txt.style.opacity        = '1';
        });
      });

      // PUB_SUB del tema
      if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
          // usa cartData diretto se disponibile per evitare timing issues
          if (event && event.cartData) {
            var cart = event.cartData;
            if (!cart.items || typeof cart.total_price === 'undefined') {
              setTimeout(checkAndManageGift, 400);
              return;
            }
            var total = cart.total_price;
            var gift  = getGiftItem(cart);

            if (total < GIFT.THRESHOLD && gift) {
              GIFT._busy = true;
              var lineIdx = getGiftLineIndex(cart);
              cartRemove(lineIdx).then(function () {
                closePanel();
                refreshDrawer();
                GIFT._busy = false;
              }).catch(function () { GIFT._busy = false; });
              return;
            }

            if (total >= GIFT.THRESHOLD && !gift) {
              setTimeout(checkAndManageGift, 400);
              return;
            }

            // omaggio presente e soglia ok — aggiorna solo qty lock
            if (total >= GIFT.THRESHOLD && gift) {
              lockGiftQty();
            }
            return;
          }
          setTimeout(checkAndManageGift, 400);
        });
      }

      // MutationObserver apertura drawer
      watchDrawerOpen();

      // run iniziale
      checkAndManageGift();

    }).catch(function (e) {
      console.error('PB Gift: errore caricamento prodotto', e);
    });
  });

})();